import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useEffect, useState } from "react";
import {
  ArrayPath,
  FieldArray,
  FieldArrayWithId,
  FieldPath,
  FieldValues,
  UseFieldArrayRemove,
  UseFieldArrayUpdate,
  UseFormReturn,
} from "react-hook-form";
import { MdPlaylistRemove } from "react-icons/md";
import { RxDragHandleHorizontal } from "react-icons/rx";
import { URLS } from "../../Consts/URL";
import { fetchApi } from "../../Helpers/Functions";
import { useTripsStore } from "../../store/TripsStore";
import { TripPoint } from "../../Types/Trip";
import { Button } from "../ui/Button";
import { FormControl, FormField, FormItem, FormLabel } from "../ui/Form";
import { Input } from "../ui/Input";

export default function SelectPointDDL<T extends FieldValues>({
  form,
  index,
  fieldsLength,
  fieldObject,
  removeItem,
  update,
}: {
  form: UseFormReturn<T>;
  index: number;
  fieldsLength: number;
  fieldObject: FieldArrayWithId<T, ArrayPath<T>, "id">;
  removeItem: UseFieldArrayRemove;
  update: UseFieldArrayUpdate<T, ArrayPath<T>>;
}) {
  const upsertRoutePoints = useTripsStore((state) => state.upsertRoutePoints);
  const deleteRoutePoints = useTripsStore((state) => state.deleteRoutePoints);
  const newTrip = useTripsStore((state) => state.newTrip);
  console.log("newTrip points", newTrip.points);
  const [query, setQuery] = useState("");
  // get places
  useEffect(() => {
    const tt = setTimeout(() => {
      if (query && query !== selectedPlace.display_name) {
        fetchApi(
          // URL.getTomTomGeocodingUrl(query)
          URLS.postGoogleAutocompleteUrl(),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Goog-Api-Key": import.meta.env.VITE_GOOGLE_MAPS,
            },
            body: JSON.stringify({
              input: query,
              includedRegionCodes: ["us"],
            }),
          }
        )
          .then((res) => res.json())
          .then((data: any) => {
            const placesText = data?.suggestions?.map((suggestion: any) => ({
              display_name: suggestion.placePrediction.text.text,
              place_id: suggestion.placePrediction.placeId,
            }));
            if (placesText) setPlacesOptions(placesText);
          });
      } else {
        setPlacesOptions([]);
      }
    }, 700);
    return () => {
      clearTimeout(tt);
    };
  }, [query]);

  const [placesOptions, setPlacesOptions] = useState<
    Array<{
      display_name: string;
      place_id: string;
    }>
  >([]);
  const [selectedPlace, setSelectedPlace] = useState({
    place_id: "",
    display_name: "",
  });
  // get coords
  useEffect(() => {
    if (selectedPlace.place_id) {
      const get = async () => {
        return fetchApi(
          URLS.getGoogleGeocodingPlaceIdUrl(String(selectedPlace.place_id))
        )
          .then((res) => res.json())
          .then((data) => {
            return {
              lat: Number(data?.results[0]?.geometry.location.lat),
              lon: Number(data?.results[0]?.geometry.location.lng),
              address: data?.results[0].formatted_address,
              title: "",
            } as TripPoint;
          });
      };
      get().then((d) => {
        upsertRoutePoints({ ...d, index }, index);
        update(index, { ...d, index } as FieldArray<T, ArrayPath<T>>);
      });
    }
  }, [selectedPlace]);

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: fieldObject.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  return (
    <div
      style={style}
      ref={setNodeRef}
      className="flex items-center justify-between"
    >
      <FormField
        control={form.control}
        name={`points.${index}.address` as FieldPath<T>}
        render={({ field }) => {
          return (
            <FormItem className="flex items-center gap-3 w-10/12">
              <FormLabel className="text-nowrap text-xs">
                {index + 1}.
              </FormLabel>
              <FormControl>
                <div style={{ width: "100%" }}>
                  <Input
                    onInput={(e) => {
                      setQuery(e.currentTarget.value);
                    }}
                    placeholder="Point"
                    {...field}
                    // @ts-ignore (not grniric :/)
                    value={query || fieldObject?.address}
                  />
                  {!!placesOptions.length && (
                    <ol>
                      {placesOptions.map((po) => {
                        return (
                          <li
                            key={po.place_id}
                            className="hover:bg-slate-400 hover:cursor-pointer"
                            data-value={po?.place_id}
                            onClick={(e) => {
                              const p = placesOptions.find(
                                (po) =>
                                  po.place_id === e.currentTarget.dataset.value
                              );
                              if (p) {
                                setSelectedPlace(p);
                                setQuery("");
                              }
                            }}
                          >
                            {po?.display_name}
                          </li>
                        );
                      })}
                    </ol>
                  )}
                </div>
              </FormControl>
            </FormItem>
          );
        }}
      />
      <div {...attributes} {...listeners}>
        <RxDragHandleHorizontal className="cursor-move" />
      </div>
      <Button
        className="cursor-pointer h-7"
        disabled={fieldsLength <= 2}
        onClick={() => {
          removeItem(index);
          deleteRoutePoints(index);
        }}
      >
        <MdPlaylistRemove />
      </Button>
    </div>
  );
}
